module.exports = __webpack_public_path__ + "img/nav-3.2bd0c95.png";